import React from "react";

export const ContactForm = ({
  setName,
  setPhone,
  setEmail,
  handleSubmit
}) => {
  return (
        <form onSubmit={handleSubmit}>
          <div className="mb-3">
            <label htmlFor='name' className='form-label'>Name</label>
            <input className="form-control" type="text" name="name" id="name" placeholder="Full name" onChange={(e) => setName(e.target.value)} />
          </div>
          <br/>
          <div className='mb-3'>
            <label htmlFor='phone'>Mobile Phone</label>
            <input className='form-control' type="tel" name="phone" id="phone" placeholder="Mobile Phone Number (format must match: 07123 456 789)" pattern='^07\d{3}\s\d{3}\s\d{3}' onChange={(e)=>setPhone(e.target.value) } />
          </div>
          <br/>
          <div className='mb-3'>
            <label htmlFor='email'>Email</label>
            <input className='form-control' type="email" name="email" id="email" placeholder="E-mail" patter='^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$' onChange={(e) => setEmail(e.target.value)} />
          </div>
          <br/>
          <button type="submit" className='btn btn-primary'>Submit</button>
        </form>
  );
};
